module.exports = ".pagination {\n  font-size: 100%; }\n  .pagination a {\n    margin-left: 10px;\n    margin-right: 10px; }\n  .pagination a.active {\n      color: #333; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Styles/product.pagination.scss
// module id = ./src/app/Styles/product.pagination.scss
// module chunks = main